import React from 'react';
import { useTranslation } from 'react-i18next';
import { Phone, Mail, MapPin, Linkedin, ClipboardCheck, ArrowRight } from 'lucide-react';
import './Footer.css';

const Footer = ({ scrollToSection }) => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-cta">
        <div className="footer-cta-content">
          <div className="footer-cta-text">
            <ClipboardCheck className="footer-cta-icon" />
            <span>{t('urgency.title')}</span>
          </div>
          <button onClick={() => scrollToSection('contact')} className="footer-cta-btn">
            {t('nav.quote')}
            <ArrowRight size={16} />
          </button>
        </div>
      </div>

      <div className="footer-main">
        <div className="footer-inner">
          <div className="footer-brand">
            <img src="/logos/meccaflex-isometric-logo.svg" alt="MeccaFlex" className="footer-logo" />
          </div>

          <nav className="footer-nav">
            <button onClick={() => scrollToSection('hero')}>{t('footer.navigation.home')}</button>
            <button onClick={() => scrollToSection('come-funziona')}>{t('nav.howItWorks')}</button>
            <button onClick={() => scrollToSection('servizi')}>{t('nav.services')}</button>
            <button onClick={() => scrollToSection('rate-card')}>{t('nav.rates')}</button>
            <button onClick={() => scrollToSection('contact')}>{t('contact.label')}</button>
          </nav>

          <div className="footer-contact">
            <a href="mailto:info@meccaflex.com">
              <Mail size={14} />
              info@meccaflex.com
            </a>
            <a href="tel:+393401234567">
              <Phone size={14} />
              +39 340 123 4567
            </a>
            <span className="footer-location">
              <MapPin size={14} />
              EU
            </span>
          </div>

          <div className="footer-social">
            <a href="https://linkedin.com/company/meccaflex" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <Linkedin size={18} />
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <span>© {currentYear} MeccaFlex Ltd</span>
        <div className="footer-legal">
          <button>{t('footer.legal.privacy')}</button>
          <button>{t('footer.legal.terms')}</button>
          <a href="#contact">Request a free screen</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
